export default __webpack_public_path__ + "static/media/LOGO-Smart-Inspection.6ddbd1c0.png";